import { Icon20WriteOutline } from '@vkontakte/icons';
import React, { type MouseEvent, forwardRef } from 'react';
import { MenuButton } from 'reactApp/ui/ReactViewer/ViewerMenu/MenuButton/MenuButton';

interface Props {
    hint?: string;
    qaId?: string;
    onClick?: (evt: MouseEvent) => void;
}

export const EditMenuButton = forwardRef<HTMLDivElement, Props>(({ hint = 'Редактировать', onClick, qaId = 'edit' }, ref) => {
    return <MenuButton hint={hint} icon={<Icon20WriteOutline />} onClick={onClick} qaId={qaId} ref={ref} />;
});

EditMenuButton.displayName = 'EditMenuButton';
